<div class="SelectedProductsBody" *ngIf="this.parent.Cart?.Items?.length > 0;">
 
 <div class="CartTitle MainCartTitle unSelectable">
    <i class="material-icons">shopping_cart</i>
    <span>{{'MyCart' | translate}}</span>
 </div>

  <div class="CartSummary CartSummarySmaller">
    <div class="CartTitle unSelectable">
      <i *ngIf="this.ShowStockProducts == true;" (click)="this.ShowStockProducts = !this.ShowStockProducts" class="material-icons">keyboard_arrow_down</i>
      <i *ngIf="this.ShowStockProducts != true;" (click)="this.ShowStockProducts = !this.ShowStockProducts" class="material-icons">keyboard_arrow_right</i>
      <span (click)="this.ShowStockProducts = !this.ShowStockProducts">{{'Products' | translate}}</span>
    </div>
  
    <div *ngIf="this.ShowStockProducts == true;">
      <div class="GridContainer unSelectable">
        <div class="GridRow">
          <!-- <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5% - 2px); background: #fff;">
            <mat-checkbox class="GridCheckBox" [(ngModel)]="this.parent.SelectedGrid" (change)="this.parent.SelectAll();"></mat-checkbox>
          </div> -->
          <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);">
            #
          </div>
      
          <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(10%);">
            {{'Brand' | translate}}
          </div>
      
        <div class="GridCol GridHeadderCol unSelectable leftText" style="width: Calc(30%);" matTooltip="{{ 'ProductNamePartNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>
           {{'ProductNamePartNumber' | translate}}
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);">
          {{'Quantity' | translate}}
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(7.5%);">
          {{'Price' | translate}}
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(7.5%);">
          {{'Total' | translate}}
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(10%);">
          {{'ETA' | translate}}
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(8%);">
            HSCode
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);">
            COO
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(7%);">
            {{'Weight' | translate}}
        </div>
      
        <div class="GridCol GridHeadderCol unSelectable" style="width: Calc(5%);border-right: solid 1px #aaa;">
          {{'Actions' | translate}}
        </div>
        </div>
      
        <div class="GridRow" *ngFor="let item of this.parent.CartItemRows; let i = index;">
          <!-- <div class="GridCol" style="width: Calc(5% - 2px); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (mouseover)="this.parent.handleMouseOver($event, item)" (mousedown)="this.parent.handleMouseDown()" (mouseup)="this.parent.handleMouseUp()" (mouseleave)="this.parent.handleMouseLeave()">
            <mat-checkbox class="GridCheckBox" [(ngModel)]="item.IsSelected"></mat-checkbox>
          </div> -->
          <div class="GridCol" style="width: Calc(5% - 2px);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
            {{i + 1}}
          </div>
      
          <div class="GridCol leftText" style="width: Calc(10%);  cursor: pointer;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}" (click)="this.parent.InitializeSearchProduct(item);">
            <span *ngIf="item?.CartItemStatus?.ID >= 0;">{{item?.Product?.Brand?.Name}}</span>
            <span *ngIf="item?.CartItemStatus?.ID == -1;">{{'ItemNeedsSelection' | translate}}</span>
            <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null;">
              <i class="material-icons SelectBrandIcon">keyboard_arrow_down</i>
              {{'SelectBrand' | translate}}
            </span>
      
            <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null;">
              {{item?.UserSelectedBrand?.Name}}
            </span>
      
            <div *ngIf="item.ShowBrandSearchResults == true;" class="GridBrandSearchResults">
              <div class="GridBrandSearchResultsTopSearch">
                <input type="text" placeholder="ex: SIEMENS" [(ngModel)]="this.parent.brandSearch" class="GridBrandSearchInput" matInput (ngModelChange)="this.parent.GetBrandsFilteredWithSuggestion(this.parent.brandSearch);"/>
              </div>
              <div class="GridBrandSearchResultsBody" *ngIf="this.parent.BrandsLoading != true;">
                <div class="GridBrandSearchRow" *ngFor="let brand of this.parent.Brands; let b = index;" (click)="this.parent.SelectItemBrand(item, brand);">
                  <span>{{brand.Name}}</span>
                </div>
              </div>
              <mat-spinner *ngIf="this.parent.BrandsLoading == true;" diameter="25" class="BrandsLoadingSpinner"></mat-spinner>
            </div>
          </div>
      
          <div class="GridCol leftText" style="width: Calc(30%); background: #fff;padding-left: 0!important; cursor: pointer;" [ngClass]="{'awaitingChoiceMarkedRows': item?.CartItemStatus?.ID == -1, 'notFoundMarkedRows': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'validMarkedRows': item?.CartItemStatus?.ID == 1, 'invalidMarkedRows': item?.CartItemStatus?.ID == 0, 'blinking-background': item.LoadingCell == true}">
            <textarea [disabled]="item.LoadingCell" class="GridColFullText" type="text" (click)="this.parent.InitializeSearchProduct(item);" [(ngModel)]="item.UIProductValue" matInput (ngModelChange)="this.parent.searchTermUpdate.next($event)"></textarea>
            <i class="material-icons cellCheckIcon" *ngIf="item?.CartItemStatus?.ID == 1;">check</i>
            <i class="material-icons cellDownIcon" *ngIf="item?.CartItemStatus?.ID == -1;">keyboard_arrow_down</i>
            <div *ngIf="item.ShowSearchResults == true && item?.SearchResults?.length > 0;" class="itemChoiceContainer">
              <div class="itemChoiceContainerTitle">{{'SimilarProducts' | translate}}</div>
              <div *ngFor="let s of this.item.SearchResults; let j = index;" class="cellSearchResultRow" (click)="this.parent.SelectGridSearchResult(s, item);" [ngClass]="{'SelectedOfferRow': s.IsSelected == true}">
                <span>{{s.FKBrandName}}</span>  
                <span>{{s.ProductName}}</span> <span *ngIf="s.ProductPartNumber?.length > 0;">(PN: {{s.ProductPartNumber}})</span>
                <i class="material-icons SelectedGridSearchResult" *ngIf="s.IsSelected == true;">check</i>
              </div>
            </div>
          </div>
      
          <div class="GridCol" style="width: Calc(5%); background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
            <div class="MOQSign" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true" matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
            <input style="text-align: center; width: 100%; margin:0%;" class="GridColFullText" type="text" [(ngModel)]="item.Quantity" matInput *ngIf="item.Quantity > 0" (ngModelChange)="this.parent.OnlyNumbers($event)" (change)="this.parent.ChangeGridCellItem(item);"/>
          </div>
      
          <div class="GridCol" style="width: Calc(7.5%);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
            <div (click)="this.parent.PrepareGridCellItemSideOffers(item);" class="SpecialOfferSign" *ngIf="item?.SelectedOffer?.SpecialOffer?.SpecialOfferPrice > 0;" matTooltip="Special: {{item?.SelectedOffer?.SpecialOffer?.SpecialOfferPrice}} {{item?.SelectedOffer?.SpecialOffer?.Currency?.Name}} - min. x{{item?.SelectedOffer?.SpecialOffer?.MOQ}}" matTooltipClass='neutral-tool-tip'></div>
            {{item.Price?.UIUnitPrice}} {{item.Price?.Currency?.Symbol}}
          </div>
      
          <div class="GridCol" style="width: Calc(7.5%);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
            {{item.Price?.UIQtyPrice}} {{item.Price?.Currency?.Symbol}}
          </div>
      
        <div class="GridCol" style="width: Calc(10%);" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
          <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == -1" style="background: #f60;" matTooltip="{{item.RequestDeliveryStatus?.Description}}" matTooltipClass='neutral-tool-tip'></span>
          <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 0" style="background: #32aa3a;" matTooltip="{{item.RequestDeliveryStatus?.Description}}" matTooltipClass='neutral-tool-tip'></span>
          <span class="DottStatus" *ngIf="item.RequestDeliveryStatus?.ID == 1" matTooltip="{{item.RequestDeliveryStatus?.Description}}" matTooltipClass='neutral-tool-tip'></span>
          <span *ngIf="item.SelectedOffer?.LeadTime != null;">{{item.SelectedOffer?.LeadTime?.Units}} {{item.SelectedOffer?.LeadTime?.Type?.Name}}</span>
          <span *ngIf="item.SelectedOffer?.LeadTime == null;">------</span>
          <div matTooltip="{{'DeliveryOptions' | translate}}" matTooltipClass='neutral-tool-tip' (click)="this.parent.PrepareGridCellItemSideOffers(item);" *ngIf="item.Product?.HasStockOffers == true" class="StockOptionsButton">
            <i class="material-icons">settings</i>
          </div>
        </div>
      
        <div class="GridCol" style="width: 8%;">
          {{item.Product?.Stats?.HSCode}}
        </div>
      
        <div class="GridCol" style="width: 5%;">
          {{item.Product?.Stats?.COO?.ShortName}}
        </div>
      
        <div class="GridCol" style="width: 7%;">
          {{item.Product?.Stats?.Weight}} {{item.Product?.Stats?.WeightMeasurementType?.Name}}
        </div>
        
      
        <div class="GridCol" style="width: Calc(5%);border-right: solid 1px #aaa; background: #fff;" [ngClass]="{'SelectedOfferRow': item?.IsSelected == true}">
          <i class="material-icons RemoveItemGridIcon" (click)="this.parent.RemoveItem(item);">close</i>
        </div>
        </div>
      
        <button mat-flat-button color="primary" (click)="this.parent.PopulateCartItems(1)" class="AddRowsButton" style="background: #4d148c;">
          <i class="material-icons">add</i>
          <span> 1 {{'Rows' | translate}}</span>
        </button>
      
        <button mat-flat-button color="primary" (click)="this.parent.PopulateCartItems(10)" class="AddRowsButton" style="background: #4d148c;">
          <i class="material-icons">add</i>
          <span> 10 {{'Rows' | translate}}</span>
        </button>
      
        <button mat-flat-button color="primary" (click)="this.parent.PopulateCartItems(50)" class="AddRowsButton" style="background: #4d148c;">
          <i class="material-icons">add</i>
          <span> 50 {{'Rows' | translate}}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="CartSummary CartSummarySmaller">
    <div class="CartTitle unSelectable">
      <i *ngIf="this.ShowBillingInformation == true;" (click)="this.ShowBillingInformation = !this.ShowBillingInformation" class="material-icons">keyboard_arrow_down</i>
      <i *ngIf="this.ShowBillingInformation != true;" (click)="this.ShowBillingInformation = !this.ShowBillingInformation" class="material-icons">keyboard_arrow_right</i>
      <span (click)="this.ShowBillingInformation = !this.ShowBillingInformation">{{'MyBillingInformation' | translate}}</span>
    </div>
  
    <div *ngIf="this.ShowBillingInformation == true;">
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.Name?.length > 0;">
        <span class="BillingInfoPTitle">{{'Name' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.Name}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.VAT?.length > 0;">
        <span class="BillingInfoPTitle">{{'VAT' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.VAT}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.COCRegNumber?.length > 0;">
        <span class="BillingInfoPTitle">{{'COCRegNumber' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.COCRegNumber}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.BillingAddress?.Country?.Name?.length > 0;">
        <span class="BillingInfoPTitle">{{'Country' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.BillingAddress.Country.Name}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.BillingAddress?.StateProvince?.length > 0;">
        <span class="BillingInfoPTitle">{{'StateProvince' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.BillingAddress.StateProvince}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.BillingAddress?.City?.length > 0;">
        <span class="BillingInfoPTitle">{{'City' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.BillingAddress.City}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.BillingAddress?.AddressLine?.length > 0;">
        <span class="BillingInfoPTitle">{{'AddressLine' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.BillingAddress.AddressLine}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.BillingAddress?.ZipCode?.length > 0;">
        <span class="BillingInfoPTitle">{{'ZipCode' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.BillingAddress.ZipCode}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.ContactInfo?.Name?.length > 0;">
        <span class="BillingInfoPTitle">{{'Name' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.ContactInfo.Name}}</span>
      </p>
  
      <p class="BillingInfoP" *ngIf="this.parent.Cart?.Partner?.ContactInfo?.Phone?.length > 0;">
        <span class="BillingInfoPTitle">{{'Phone' | translate}}: </span>
        <span class="BillingInfoPDescription">{{this.parent.Cart.Partner.ContactInfo.Phone}}</span>
      </p>
    </div>
  </div>

  <div class="CartSummary CartSummarySmaller">
    <div class="CartTitle unSelectable">
      <i *ngIf="this.ShowShippingInformation == true;" (click)="this.ShowShippingInformation = !this.ShowShippingInformation" class="material-icons">keyboard_arrow_down</i>
      <i *ngIf="this.ShowShippingInformation != true;" (click)="this.ShowShippingInformation = !this.ShowShippingInformation" class="material-icons">keyboard_arrow_right</i>
      <span (click)="this.ShowShippingInformation = !this.ShowShippingInformation">{{'MyShippingInformation' | translate}}</span>
    </div>
  
    <div *ngIf="this.ShowShippingInformation == true;">
      <mat-form-field appearance="outline"class="ShippingAddressDropBox" *ngIf="this.parent.Cart.Partner.ShippingAddresses?.length > 0 && this.LoadShippingAddresses != true;">
        <mat-label>{{ 'ShippingAddresses' | translate }}</mat-label>
        <mat-select name="ShippingAddresses" [compareWith]="this.parent.compareSelection" [(ngModel)]="this.CurrentShippingAddress" style="height: 30px;padding-top: 7px;">
          <mat-option *ngFor="let a of this.parent.Cart.Partner.ShippingAddresses" [value]="a" (click)="SelectShippingAddressAddress(a)">
            {{a.Country.Name}} {{a.City}} {{a.AddressLine}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <div *ngFor="let a of this.parent.Cart.Partner.ShippingAddresses">
        <div *ngIf="a.IsSelected == true && a.ActiveAddress == true;">
  
          <p class="BillingInfoP" *ngIf="a.Country?.Name?.length > 0;">
            <span class="BillingInfoPTitle">{{'Country' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.Country?.Name}}</span>
          </p>
  
          <p class="BillingInfoP" *ngIf="a.State?.length > 0;">
            <span class="BillingInfoPTitle">{{'StateProvince' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.State}}</span>
          </p>
  
          <p class="BillingInfoP" *ngIf="a.City?.length > 0;">
            <span class="BillingInfoPTitle">{{'City' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.City}}</span>
          </p>
  
          <p class="BillingInfoP" *ngIf="a.AddressLine?.length > 0;">
            <span class="BillingInfoPTitle">{{'AddressLine' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.AddressLine}}</span>
          </p>
  
          <p class="BillingInfoP" *ngIf="a.ZipCode?.length > 0;">
            <span class="BillingInfoPTitle">{{'ZipCode' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.ZipCode}}</span>
          </p>
  
          <p class="BillingInfoP" *ngIf="a.Email?.length > 0;">
            <span class="BillingInfoPTitle">{{'Email' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.Email}}</span>
          </p>
  
          <p class="BillingInfoP" *ngIf="a.Phone?.length > 0;">
            <span class="BillingInfoPTitle">{{'Phone' | translate}}: </span>
            <span class="BillingInfoPDescription">{{a.Phone}}</span>
          </p>
  
        </div>
      </div>
    </div>
  </div>

  <div class="CartSummary unSelectable CartSummarySmaller">
    <div class="CartSummaryTitle">
      <p>{{'OrderContactAgents' | translate}}</p>
    </div>
  
    <div class="PartnerAgentRow" *ngFor="let agent of this.parent.B2BPartner?.PartnerAgents" [ngClass]="{ 'UnSelectedAgent': agent.IsSelected != true}" (click)="agent.IsSelected = !agent.IsSelected;">
      <p>{{agent.Email}}</p>
      <i class="material-icons" *ngIf="agent.IsSelected == true;" style="color: #32aa3a;">check</i>
      <i class="material-icons" *ngIf="agent.IsSelected != true;" style="color: #fd4f57;">close</i>
    </div>
  </div>
</div>

<div class="CartSummary">
  <div class="CartSummaryTitle">
    <p>{{'CartSummary' | translate}}</p>
  </div>

  <div class="CartSummaryBody">
    <div class="fullWidth" style="float:left;">

     <div class="CartItemSummaryContainer" *ngIf="this.parent.Cart?.QuotationItems?.length > 0;" style="margin: 0;">
      <i class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'QuotationItemsDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
      <p class="CartItemSummaryContainerTitle">
        <span class="CartItemSummaryContainerTitleLeft">{{'QuotationItems' | translate}}: </span>
        <span class="CartItemSummaryContainerTitleRight">{{this.parent.Cart?.QuotationItems?.length}}</span>
      </p>
    </div>

    <div class="CartItemSummaryContainer" *ngIf="this.parent.Cart?.SellingItems?.length > 0;" style="margin: 0;">
      <i class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'SellingItemsDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
      <p class="CartItemSummaryContainerTitle">
        <span class="CartItemSummaryContainerTitleLeft">{{'SellingItems' | translate}}: </span>
        <span class="CartItemSummaryContainerTitleRight">{{this.parent.Cart?.SellingItems?.length}}</span>
      </p>
    </div>

      <div class="CartItemSummaryContainer" *ngIf="this.parent.Cart?.ListPriceItems?.length > 0;">
        <i class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'ListPriceItemsDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
        <p class="CartItemSummaryContainerTitle">
        <span class="CartItemSummaryContainerTitleLeft">{{'ListPriceItems' | translate}}: </span>
        <span class="CartItemSummaryContainerTitleRight">{{this.parent.Cart?.ListPriceItems?.length}}</span>
      </p>
     </div>

     <div class="CartItemSummaryContainer">
      <i class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'EstimatedWeightDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
      <p class="CartItemSummaryContainerTitle">
        <span class="CartItemSummaryContainerTitleLeft">{{'EstimatedWeight' | translate}}: </span>
        <span class="CartItemSummaryContainerTitleRight">{{this.parent.Cart?.Weight}} {{this.parent.Cart?.WeightMeasurementType?.Name}}</span>
      </p>
     </div>

     <div class="CartItemSummaryContainer" *ngIf="this.parent.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer > 0;">
      <i class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'TotalPricedProductsDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
      <p class="CartItemSummaryContainerTitle" *ngIf="this.parent.Cart?.Weight > 0;" style="margin: 0;">
        <span class="CartItemSummaryContainerTitleLeft">{{'TotalPricedProducts' | translate}}: </span>
        <span class="CartItemSummaryContainerTitleRight">{{this.parent.Cart?.Total.UITotalQtyPriceNOVAT.Integer}} {{this.parent.Cart?.Total.UITotalQtyPriceNOVAT.Decimals}} {{this.parent.Cart?.Currency?.Name}}</span>
      </p>
     </div>

      <mat-form-field style="width: 100%;" appearance="outline"class="ProductPropertyTextBox" *ngIf="this.parent.CartMasterData != null && this.parent.CartMasterData.CartPayments != null;">
        <mat-label>{{ 'PaymentType' | translate }}</mat-label>
        <mat-select name="PaymentType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.parent.Cart.PaymentType" style="height: 30px;padding-top: 7px;">
          <mat-option [disabled]="p.Disabled" *ngFor="let p of this.parent.CartMasterData.CartPayments" [value]="p">
            {{p.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline"class="ProductPropertyTextBox" *ngIf="this.parent.CartMasterData != null && this.parent.CartMasterData.ShippingResponsabilities != null;">
        <mat-label>{{ 'ShippingResponsability' | translate }}</mat-label>
        <mat-select name="ShippingResponsability" [compareWith]="this.parent.compareFn" [(ngModel)]="this.parent.Cart.ShippingResponsability" style="height: 30px;padding-top: 7px;">
          <mat-option [disabled]="p.Disabled" *ngFor="let p of this.parent.CartMasterData.ShippingResponsabilities" [value]="p">
            {{p.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field style="width: 100%;" appearance="outline"class="ProductPropertyTextBox" *ngIf="this.parent.CartMasterData != null && this.parent.CartMasterData.ShippingServiceTypes != null;">
        <mat-label>{{ 'ShippingServiceType' | translate }}</mat-label>
        <mat-select name="ShippingServiceType" [compareWith]="this.parent.compareFn" [(ngModel)]="this.parent.Cart.ShippingServiceType" style="height: 30px;padding-top: 7px;">
          <mat-option [disabled]="p.Disabled" *ngFor="let p of this.parent.CartMasterData.ShippingServiceTypes" [value]="p">
            {{p.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="ProductPropertyTextBox">
        <mat-label>{{ 'Receptions.Mentions' | translate }}</mat-label>
        <textarea autocomplete="off" matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="10"
                    [(ngModel)]="OfferRequest.Observations"></textarea>
      </mat-form-field>

      <div class="CartItemSummaryContainer">
        <i class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'PaymentConditionsDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
        <p class="CartItemSummaryContainerTitle">{{'PaymentConditions' | translate}}: 
          <span class="CartItemSummaryContainerTitleLeft" *ngIf="this.parent.Cart?.PaymentTerm?.Days > 0;">{{'PaymentTerms' | translate}} </span>
          <span class="CartItemSummaryContainerTitleRight">{{this.parent.Cart.PaymentTerm.Name}}</span>
        </p>
      </div>

      <div class="TextBoxTitle">{{'UIPartnerReferenceNumber' | translate}} ({{'Recommended' | translate}})</div> 
        <div class="CentralTextBoxContainer">
        <i style="color: #f60;" class="material-icons CartItemSummaryContainerIcon" matTooltip="{{'UIPartnerReferenceNumberDescription' | translate}}" matTooltipClass='neutral-tool-tip'>info_outline</i>
        <input type="text" class="TextBoxContainer DebatorPOStyle" placeholder="{{'UIPartnerReferenceNumber' | translate}} ({{'Recommended' | translate}})" [(ngModel)]="this.parent.OfferRequest.DebatorPO" matInput>
      </div>

      <div class="GridCommandCenter">
        <button disabled="true" mat-flat-button color="primary" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID == -1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons">local_offer</i>
          <span>{{'SendRFQ' | translate}}</span>
        </button>
      
        <button (click)="this.parent.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 1;">
          <i class="material-icons">local_offer</i>
          <span>{{'SendRFQ' | translate}}</span>
        </button>
      
        <button (click)="this.parent.OpenAskAddNewRFQQuestion();" mat-flat-button color="primary" class="AddRowsButton" style="background: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 0;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons">local_offer</i>
          <span>{{'SendRFQ' | translate}}</span>
        </button>
      
        <button disabled="true" mat-stroked-button color="primary" class="AddRowsButton" *ngIf="this.parent.Cart?.Status?.ID != 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons">check</i>
          <span>{{'SendPO' | translate}}</span>
        </button>
      
        <button (click)="this.parent.OpenAskAddNewRFQasPOQuestion();" mat-stroked-button color="primary" class="AddRowsButton AddNewPOButton" style="color: #4d148c;" *ngIf="this.parent.Cart?.Status?.ID == 1;" matTooltip="{{this.parent.Cart?.Status?.Description}}" matTooltipClass='neutral-tool-tip'>
          <i class="material-icons">check</i>
          <span>{{'SendPO' | translate}}</span>
        </button>
      
        <!-- <mat-form-field class="OfferPriorityStatusesSelect" appearance="outline">
          <mat-label>{{ 'SelectOfferPriority' | translate }}</mat-label>
          <mat-select name="Language" [compareWith]="parent.compareFn" [(ngModel)]="this.parent.OfferPriorityStatus">
            <mat-option *ngFor="let prio of this.parent.OfferPriorityStatuses; index as i" [value]="prio">
              {{prio.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field> -->
      </div>
    </div>
  </div>
</div>